import React from 'react';

type LoadMoreButtonProps = {
    show: boolean;
    loading: boolean;
    onClick: () => void;
};

export default function LoadMoreButton({ show, loading, onClick }: LoadMoreButtonProps) {
    if (!show) return null;

    return (
        <section className="no-gap">
            <div className="inner-box">
                <button
                    type="button"
                    className="page-more-btn"
                    onClick={onClick}
                    disabled={loading}
                >
                    {loading ? (
                        <>로딩 중...</>
                    ) : (
                        <>
                            더보기 <i className="fa-solid fa-chevron-down"></i>
                        </>
                    )}
                </button>
            </div>
        </section>
    );
}